<div class="flex justify-center">

<div class="kt-card w-[420px] p-8">

<h3 class="text-lg font-semibold mb-6">
Enable Two Factor Authentication
</h3>

<div *ngIf="!success">

<p class="mb-4 text-sm text-gray-600">
Scan the QR code using Google Authenticator.
</p>

<div class="flex justify-center mb-4">

<img
class="border p-2"
[src]="'data:image/png;base64,' + qrCode"
/>

</div>

<div class="text-center text-xs text-gray-500 mb-6">

Secret Key:
<span class="font-mono">{{secret}}</span>

</div>

<div class="flex flex-col gap-2">

<input
class="kt-input"
placeholder="Enter 6 digit code"
[(ngModel)]="otpCode"
maxlength="6"
/>

<button
class="kt-btn kt-btn-primary"
(click)="verify()"
[disabled]="loading"
>

Verify & Enable

</button>

</div>

<div
*ngIf="error"
class="text-red-500 text-sm mt-3"
>

{{error}}

</div>

</div>

<div *ngIf="success" class="text-center">

<div class="text-green-600 font-medium mb-3">

2FA Successfully Enabled

</div>

<p class="text-sm text-gray-500">
Your account is now protected with
Google Authenticator.
</p>

</div>

</div>

</div>
